import React from "react";
import { HiGlobeAlt } from "react-icons/hi2";
import { useTranslation } from "react-i18next";
import "./LanguageToggle.scss";

export default function LanguageToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language === "sr" ? "en" : "sr";
    i18n.changeLanguage(newLanguage);
  };

  return (
    <button className="language-toggle" onClick={toggleLanguage}>
      <HiGlobeAlt />
      <span>{i18n.language === "sr" ? "EN" : "СР"}</span>
    </button>
  );
}
